#import "../fragments/mcfx-form-fragment.graphql"

query GetMcfxForms($filters: McfxFormsInput!, $limit: Int!, $after: String) {
    mcfxForms(filters: $filters, first: $limit, after: $after) {
        totalCount
        pageInfo {
            endCursor
            hasNextPage
        }
        edges {
            cursor
            node {
                ...McfxFormFragment
            }
        }
    }
}
